"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_monitor__brightness__contrast__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "7e06e022-4fbd-4548-8530-dfc00b3674ac",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "monitor-brightness-contrast-hi-dark"), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.02,
    y: 16,
    width: 160,
    height: 160,
    rx: 80,
    ry: 80,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174h0a80.23,80.23,0,0,1-80-79c0,.34,0,.67,0,1h0a80.24,80.24,0,0,0,80,80h0a80.24,80.24,0,0,0,80-80h0c0-.33,0-.66,0-1A80.23,80.23,0,0,1,96,174Z",
    transform: "translate(-0.02 -0.02)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 160,
    height: 160,
    rx: 80,
    ry: 80,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,96",
    transform: "translate(-0.02 -0.02)",
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,96",
    transform: "translate(-0.02 -0.02)",
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.02,
    y1: 44.49,
    x2: 96.02,
    y2: 58.24,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.02,
    y1: 133.76,
    x2: 96.02,
    y2: 147.51,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.49,
    y1: 96,
    x2: 58.24,
    y2: 96,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.76,
    y1: 96,
    x2: 147.51,
    y2: 96,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.7,
    y1: 59.46,
    x2: 69.42,
    y2: 69.18,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.82,
    y1: 122.58,
    x2: 132.54,
    y2: 132.3,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.46,
    y1: 132.54,
    x2: 69.18,
    y2: 122.82,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.58,
    y1: 69.42,
    x2: 132.3,
    y2: 59.7,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.17,
    cy: 96.23,
    r: 29.07,
    fill: "#c6c6c6",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.09,67.18a29.07,29.07,0,1,1,0,58.14Z",
    transform: "translate(-0.02 -0.02)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.19,122.64a29.07,29.07,0,0,1-29-27.73c0,.44,0,.89,0,1.34a29.07,29.07,0,0,0,58.14,0c0-.45,0-.9,0-1.34A29.07,29.07,0,0,1,96.19,122.64Z",
    transform: "translate(-0.02 -0.02)"
  })));
}

var _default = ic_monitor__brightness__contrast__dark;
exports.default = _default;